export default __webpack_public_path__ + "static/media/mileboard-logo.c55ce881.svg";